import { render, staticRenderFns } from "./EmailVerify.vue?vue&type=template&id=5414fc9d"
import script from "./EmailVerify.vue?vue&type=script&lang=ts"
export * from "./EmailVerify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports